import { utils } from '@weapp/ui';
import { classnames } from '@weapp/utils';
import pick from 'lodash-es/pick';
import React, { PureComponent } from 'react';
import { When } from 'react-if';
import event from '../../components/event';
import { LayoutType, pageViewClsPrefix } from '../../constants';
import { PageLayoutType } from '../../constants/pc';
import { setTimeoutOnce } from '../../utils';
import { initStyledClass } from '../../utils/page-style';
import BackgroundMask from './BackgroundMask';
import './Styled.less';
import { StyledProps, StyledStates } from './types';
import { getIsEmptyPageBgConfig } from './utils';

export default class Styled extends PureComponent<StyledProps, StyledStates> {
  constructor(props: StyledProps) {
    super(props);
    this.initStyleClsName(false);
  }

  ref = React.createRef<HTMLDivElement>();

  bgMaskRef = React.createRef<BackgroundMask>();

  parentElement: HTMLElement | null = null;

  componentDidMount() {
    const { scopeId } = this.props;
    this.initStyleClsName(true);
    this.props.mounted?.(this.ref.current!, event);
    setTimeoutOnce(() => {
      // 延迟后，页面渲染到浏览器后才能获取到dom节点
      const pageDom = document.getElementById(scopeId || '');
      const parentElement = pageDom?.parentElement?.parentElement;
      if (parentElement) {
        this.parentElement = parentElement;
        parentElement.style.transform = 'rotate(0)';
        parentElement.style.overflowY = 'hidden';
      }
    }, 100);
  }

  componentWillUnmount() {
    if (this.parentElement) {
      this.parentElement.style.removeProperty('transform');
      this.parentElement.style.removeProperty('overflow-y');
    }
  }

  getSnapshotBeforeUpdate(prevProps: StyledProps) {
    const props = ['data', 'pageBgConfig', 'scrollType', 'layoutType'];
    const changes = pick(this.props, props);
    const prevChanges = pick(prevProps, props);

    if (!utils.isEqual(changes, prevChanges)) {
      this.initStyleClsName();
    }
  }

  initStyleClsName(mounted?: boolean) {
    if (mounted === false || mounted === undefined) {
      const {
        data, scrollType, layoutType, scopeId,
      } = this.props;

      if (!data) {
        return;
      }

      initStyledClass(data, {
        scrollType,
        layoutType,
        scopeId,
      });
    }
    if (mounted === true || mounted === undefined) {
      this.props.onChange?.();
      this.props.mount?.();

      const bgMaskInstance: any = this.bgMaskRef.current;
      bgMaskInstance?.getBackgroundStyles();
    }
  }

  onClick = () => {
    const { onClick } = this.props;

    onClick?.(this.ref.current || undefined);
  };

  render() {
    const {
      childData = {},
      pageBgConfig,
      className = '',
      wrapperClsName = '',
      wrapperStyle = {},
      scrollType = '',
      layoutType,
      children,
      scopeId,
    } = this.props;
    const wrapperClsNameStr = classnames(
      `${wrapperClsName} ${pageViewClsPrefix}-styled ${scrollType} grid-layout`,
      {
        'has-sider':
          utils.isNumber(layoutType) && layoutType !== PageLayoutType.Default && layoutType! < 4,
      },
    );
    const clsNameStr = `${className}`.trim();
    const isEmptyPageBgConfig = getIsEmptyPageBgConfig(pageBgConfig);

    return (
      <div ref={this.ref} className={wrapperClsNameStr} style={wrapperStyle} onClick={this.onClick}>
        <div
          id={scopeId || ''}
          className={clsNameStr}
          style={childData}
          {...(this.props.pageWrapProps || {})}
        >
          {/* 空页面不显示背景图 */}
          <When weId={`${this.props.weId || ''}_6a08sw`} condition={!isEmptyPageBgConfig}>
            <BackgroundMask
              weId={`${this.props.weId || ''}_l5m7gb`}
              ref={this.bgMaskRef}
              pageBgConfig={pageBgConfig}
              clientType="PC"
              layoutType={LayoutType.GridLayout}
            />
          </When>
          {children}
        </div>
      </div>
    );
  }
}
